import Repository from '@/repositories/base/Repository';

export default class IntegratorBranchConfigurationsRepository extends Repository {
  async getAvailableDatabaseAlias(
    companyGroupId: number,
  ): Promise<string[]> {
    const { data: response } = await this.datasource.get(`company-groups/${companyGroupId}/integrator/branch-configurations/available-database-alias`);

    return response.data.available_database_alias;
  }
}
